/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-24 17:02:45
 * @LastEditors: K
 * @LastEditTime: 2022-09-08 10:23:52
 */
import { CaretDownFilled } from '@ant-design/icons';
import { unwrapResult } from '@reduxjs/toolkit';
import { Button, Col, Form, Row, Select, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { getAllNational } from '../../monitoring/monitoringPageSlice';
import styles from '../regulatoryDataTab.module.css'
import { Columns } from './columns';

// const { Option } = Select;
export const NationalPage = (): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const tableWrapRef = useRef<any>(null)

  // const [form] = Form.useForm();

  const [page, setPage] = useState<any>()  //表格 

  const [pageLoading, setPageLoading] = useState(false)  //表格 loading

  const [params, setParams] = useState<any>({
    current: 0
  })


  const [tableScrollY, setTableScrollY] = useState<any>('')

  const getPage = () => {
    dispatch(getAllNational())
      .then(unwrapResult)
      .then((t: any) => {
        console.log(t, 'ttttt');
        setPage(t)
      })
  }

  useEffect(() => {
    params.current && getPage()
  }, [params])

  useEffect(() => {   //固定表头
    getPage()
    const y = tableWrapRef.current.clientHeight - 263 + 'px'
    setTableScrollY(y)


  }, [])
  const data = [];
  for (let i = 0; i < 100; i++) {
    data.push({
      key: i,
      name: 'John Brown',
      age: i + 1,
      street: 'Lake Park',
      building: 'C',
      number: 2035,
      companyAddress: 'Lake Street 42',
      companyName: 'SoftLake Co',
      gender: 'M',
    });
  }


  return (
    <div className={styles.nationalPageContent}>
      {/* <Form
        form={form}
        initialValues={{ time: 0 }}
        onFinish={(values) => {
          console.log(values, 'values');
          setParams({
            ...values,
            current: 1
          })
        }}
        autoComplete="off"
      >
        <Row>
          <Col span={3}>
            <Form.Item name="time">
              <Select
                placeholder="日期选择"
                // allowClear
                // dropdownClassName={styles.select}
                suffixIcon={<CaretDownFilled />}
              >
                <Option value={0}>2022</Option>
                <Option value={3}>2021</Option>
                <Option value={5}>2020</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={2} offset={2}>
            <Button
              htmlType="submit"
              type="primary"
            >
              搜索
            </Button>
          </Col>
        </Row>
      </Form> */}

      {/* 表格区域 */}
      <div className={styles.box} ref={tableWrapRef}>
        <Table
          columns={Columns()}
          dataSource={page}
          loading={pageLoading}
          pagination={false}
          bordered
          size="middle"
          scroll={{ x: 'calc(700px + 50%)', y: tableScrollY }}
        />
      </div>
    </div>
  );
}

